import React from "react";
import { MovieTagCarousel } from "../MovieTag/MovieTagCarousel.js";
import { PersonTagCarousel } from "../PersonTag/PersonTagCarousel.js";

import "./SearchResult.css";
import { useSelector } from "react-redux";
import { extractDetailData } from "../../utility/utility.js";


export const SearchResult = (props) => {
    const {searchData} = props; //searchData: array of items
    const movieData = searchData.filter(item => item.media_type == "movie");
    const personData = searchData.filter(item => item.media_type == "person");
    const tvData = searchData.filter(item => item.media_type == "tv"); 
    let apiUtility = useSelector((state) => state.apiUtility.apiUtility);
    let { langConfig, movGenreList, tvGenreList } = apiUtility;

    
    return (
      <div className="search_result_wrapper">
        <div className="search_result_mov_wrapper">
          <div className="search_result_mov_title">
            <div>Movie</div>
            <div className="result_count">
              {movieData.length + " results found"}
            </div>
          </div>
          <div className="search_result_mov_carousel">
            <MovieTagCarousel
              movieItems={movieData.map((item) => {
                return extractDetailData(
                  "mov",
                  item,
                  langConfig,
                  movGenreList,
                  true
                );
              })}
              isHoverEnable={true}
              movieType="mov"
              isGrid={true}
              isDefaultSmall={true}
            />
          </div>
        </div>
        <div className="search_result_tv_wrapper">
          <div className="search_result_tv_title">
            <div>TV Shows</div>
            <div className="result_count">
              {tvData.length + " results found"}
            </div>
          </div>
          <div className="search_result_tv_carousel">
            <MovieTagCarousel
              movieItems={tvData.map((item) => {
                return extractDetailData(
                  "tv",
                  item,
                  langConfig,
                  tvGenreList,
                  true
                );
              })}
              isHoverEnable={true}
              isGrid={true}
              isDefaultSmall={true}
              movieType="tv"
            />
          </div>
        </div>
        <div className="search_result_person_wrapper">
          <div className="search_result_person_title">
            <div>Person</div>
            <div className="result_count">
              {personData.length + " results found"}
            </div>
          </div>
          <div className="search_result_person_carousel">
            <PersonTagCarousel personItems={personData} isGrid={true} />
          </div>
        </div>
      </div>
    );
}